import React, { useEffect, useState, useCallback } from 'react';
import { db, auth, storage } from '../firebaseConfig';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import MenuBar from '../components/MenuBar';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../utils/cropImage';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import '../styles/ProfileEdit.css';

// ユーザー入力をサニタイズする関数
const sanitizeInput = (input) => {
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
};

// 最大文字数の定義
const MAX_NAME_LENGTH = 7;
const MAX_BIO_LENGTH = 2000;
const MAX_HASHTAG_LENGTH = 20;
const MAX_HASHTAGS = 10;
const MAX_SCHOOL_NAME_LENGTH = 100;

// ファイルサイズの制限（バイト単位）
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

const ProfileEdit = () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState({
    name: '',
    bio: '',
    photoURL: '',
    birthdayYear: '',
    birthdayMonth: '',
    birthdayDay: '',
    location: '',
    height: '',
    sexualOrientation: '',
    holiday: '',
    contact: '',
    cohabitant: '',
    tobacco: '',
    alcohol: '',
    income: '',
    hope: '',
    aim: [],
    partner_sex: [],
    children_want: '',
    children_have: '',
    marital_status: '',
    friendship_marriage: '', // 友情結婚の希望
    skinship: '',
    educationc: '',
    works: '',
    figure: '',
    cohabiter_aim: '',
    sex: '',
    love_exist: '',
    marriage_aim: '',
    hashtags: [],
    sub_photoURL_1: '',
    sub_photoURL_2: '',
    sub_photoURL_3: ''
  });
  const [image, setImage] = useState(null);
  const [subImages, setSubImages] = useState([null, null, null, null, null]);
  const [subImageUrls, setSubImageUrls] = useState(['', '', '', '', '']);
  const [showSubCropper, setShowSubCropper] = useState([false, false, false, false, false]);
  const [subCroppedAreas, setSubCroppedAreas] = useState([null, null, null, null, null]);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [showCropper, setShowCropper] = useState(false);
  const [newHashtag, setNewHashtag] = useState('');
  const navigate = useNavigate();
  const [currentSubIndex, setCurrentSubIndex] = useState(null);
  const [uploading, setUploading] = useState(false);

  const yearOptions = Array.from({ length: 100 }, (_, i) => ({ value: 2023 - i, label: `${2023 - i}` }));
  const monthOptions = Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));
  const dayOptions = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));

  const ageOptions = Array.from({ length: 100 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));
  const contactFrequencyOptions = [
    { value: '毎日', label: '毎日' },
    { value: '週数回', label: '週数回' },
    { value: '週1回', label: '週1回' },
    { value: '月数回', label: '月数回' },
    { value: 'あまり連絡しない', label: 'あまり連絡しない' }
  ];
  
  const cohabitantOptions = [
    { value: '一人暮らし', label: '一人暮らし' },
    { value: '家族と同居', label: '家族と同居' },
    { value: '友達と同居', label: '友達と同居' },
    { value: 'ペットと同居', label: 'ペットと同居' },
    { value: 'その他', label: 'その他' }
  ];
  
  const tobaccoOptions = [
    { value: '吸う', label: '吸う' },
    { value: '時々吸う', label: '時々吸う' },
    { value: '吸わない', label: '吸わない' }
  ];
  
  const alcoholOptions = [
    { value: '飲む', label: '飲む' },
    { value: '時々飲む', label: '時々飲む' },
    { value: '飲まない', label: '飲まない' }
  ];
  
  const friendshipMarriageOptions = [
    { value: '希望する', label: '希望する' },
    { value: '希望しない', label: '希望しない' },
    { value: '場合による', label: '場合による' },
  ];
  

  const locationOptions = [
    { value: '北海道', label: '北海道' },
    { value: '青森', label: '青森' },
    { value: '岩手', label: '岩手' },
    { value: '宮城', label: '宮城' },
    { value: '秋田', label: '秋田' },
    { value: '山形', label: '山形' },
    { value: '福島', label: '福島' },
    { value: '茨城', label: '茨城' },
    { value: '栃木', label: '栃木' },
    { value: '群馬', label: '群馬' },
    { value: '埼玉', label: '埼玉' },
    { value: '千葉', label: '千葉' },
    { value: '東京', label: '東京' },
    { value: '神奈川', label: '神奈川' },
    { value: '新潟', label: '新潟' },
    { value: '富山', label: '富山' },
    { value: '石川', label: '石川' },
    { value: '福井', label: '福井' },
    { value: '山梨', label: '山梨' },
    { value: '長野', label: '長野' },
    { value: '岐阜', label: '岐阜' },
    { value: '静岡', label: '静岡' },
    { value: '愛知', label: '愛知' },
    { value: '三重', label: '三重' },
    { value: '滋賀', label: '滋賀' },
    { value: '京都', label: '京都' },
    { value: '大阪', label: '大阪' },
    { value: '兵庫', label: '兵庫' },
    { value: '奈良', label: '奈良' },
    { value: '和歌山', label: '和歌山' },
    { value: '鳥取', label: '鳥取' },
    { value: '島根', label: '島根' },
    { value: '岡山', label: '岡山' },
    { value: '広島', label: '広島' },
    { value: '山口', label: '山口' },
    { value: '徳島', label: '徳島' },
    { value: '香川', label: '香川' },
    { value: '愛媛', label: '愛媛' },
    { value: '高知', label: '高知' },
    { value: '福岡', label: '福岡' },
    { value: '佐賀', label: '佐賀' },
    { value: '長崎', label: '長崎' },
    { value: '熊本', label: '熊本' },
    { value: '大分', label: '大分' },
    { value: '宮崎', label: '宮崎' },
    { value: '鹿児島', label: '鹿児島' },
    { value: '沖縄', label: '沖縄' },
    { value: 'その他', label: 'その他' },
];

  const heightOptions = Array.from({ length: 70 }, (_, i) => ({ value: i + 140, label: `${i + 140} cm` }));


  const sexualOrientationOptions = [
    { value: '', label: '回答しない' },
    { value: 'ストレート', label: 'ストレート' },
    { value: 'ゲイ', label: 'ゲイ' },
    { value: 'レズビアン', label: 'レズビアン' },
    { value: 'バイセクシュアル', label: 'バイセクシュアル' },
    { value: 'パンセクシュアル', label: 'パンセクシュアル' },
    { value: 'その他', label: 'その他' },
  ];
  const spectrumOptions = [
    { value: '', label: '回答しない' },
    { value: 'アセクシュアル', label: 'アセクシュアル' },
    { value: 'グレイセクシュアル', label: 'グレイセクシュアル' },
    { value: 'デミセクシュアル', label: 'デミセクシュアル' },
    { value: 'リスセクシュアル', label: 'リスセクシュアル' },
    { value: 'ノンセクシュアル', label: 'ノンセクシュアル' },
    { value: 'その他', label: 'その他' },
  ];
  

  const holidayOptions = [
    { value: '土日', label: '土日' },
    { value: '平日', label: '平日' },
    { value: '不定期', label: '不定期' },
    { value: 'その他', label: 'その他' }
  ];

  const skinshipOptions = [
    { value: 'NGなし', label: 'NGなし' },
    { value: 'スキンシップはしたくない', label: 'スキンシップはしたくない' },
    { value: 'ハグまで', label: 'ハグまで' },
    { value: '手を繋ぐ', label: '手を繋ぐ' },
    { value: 'その他', label: 'その他' }
  ];
  
  const childrenWantOptions = [
    { value: '欲しい', label: '欲しい' },
    { value: '欲しくない', label: '欲しくない' }
  ];
  
  const childrenHaveOptions = [
    { value: 'いる', label: 'いる' },
    { value: 'いない', label: 'いない' }
  ];
  
  const maritalStatusOptions = [
    { value: '未婚', label: '未婚' },
    { value: '離婚', label: '離婚' },
  ];
  

  const incomeOptions = [
    { value: '200万円未満', label: '200万円未満' },
    { value: '200〜400万円', label: '200〜400万円' },
    { value: '400〜600万円', label: '400〜600万円' },
    { value: '600〜800万円', label: '600〜800万円' },
    { value: '800〜1000万円', label: '800〜1000万円' },
    { value: '1000万円以上', label: '1000万円以上' }
  ];
  
  const occupationOptions = [
    { value: '学生', label: '学生' },
    { value: '会社員', label: '会社員' },
    { value: '公務員', label: '公務員' },
    { value: '教員', label: '教員' },
    { value: '医師', label: '医師' },
    { value: '看護師', label: '看護師' },
    { value: '弁護士', label: '弁護士' },
    { value: 'エンジニア', label: 'エンジニア' },
    { value: 'デザイナー', label: 'デザイナー' },
    { value: 'クリエイター', label: 'クリエイター' },
    { value: '営業職', label: '営業職' },
    { value: '経営者', label: '経営者' },
    { value: 'フリーランス', label: 'フリーランス' },
    { value: '自営業', label: '自営業' },
    { value: '研究職', label: '研究職' },
    { value: '介護士', label: '介護士' },
    { value: '芸術家', label: '芸術家' },
    { value: '農業', label: '農業' },
    { value: '漁業', label: '漁業' },
    { value: '作家', label: '作家' },
    { value: '販売員', label: '販売員' },
    { value: '飲食業', label: '飲食業' },
    { value: 'サービス業', label: 'サービス業' },
    { value: '無職', label: '無職' },
    { value: '主婦/主夫', label: '主婦/主夫' },
    { value: 'アルバイト', label: 'アルバイト' },
    { value: '教師', label: '教師' },
    { value: '教授', label: '教授' },
    { value: '大学講師', label: '大学講師' },
    { value: '消防士', label: '消防士' },
    { value: '警察官', label: '警察官' },
    { value: 'パイロット', label: 'パイロット' },
    { value: 'キャビンアテンダント', label: 'キャビンアテンダント' },
    { value: '運転手', label: '運転手' },
    { value: '通訳', label: '通訳' },
    { value: '翻訳家', label: '翻訳家' },
    { value: 'ジャーナリスト', label: 'ジャーナリスト' },
    { value: '報道記者', label: '報道記者' },
    { value: 'イベントプランナー', label: 'イベントプランナー' },
    { value: '音楽家', label: '音楽家' },
    { value: '俳優', label: '俳優' },
    { value: '声優', label: '声優' },
    { value: 'ダンサー', label: 'ダンサー' },
    { value: 'モデル', label: 'モデル' },
    { value: '美容師', label: '美容師' },
    { value: 'メイクアップアーティスト', label: 'メイクアップアーティスト' },
    { value: 'アナウンサー', label: 'アナウンサー' },
    { value: 'シェフ', label: 'シェフ' },
    { value: '料理人', label: '料理人' },
    { value: 'スポーツ選手', label: 'スポーツ選手' },
    { value: 'トレーナー', label: 'トレーナー' },
    { value: 'インストラクター', label: 'インストラクター' },
    { value: 'ヨガインストラクター', label: 'ヨガインストラクター' },
    { value: 'パーソナルトレーナー', label: 'パーソナルトレーナー' },
    { value: '農家', label: '農家' },
    { value: '漁師', label: '漁師' },
    { value: '建設作業員', label: '建設作業員' },
    { value: '建築士', label: '建築士' },
    { value: '土木技師', label: '土木技師' },
    { value: '電気技師', label: '電気技師' },
    { value: '配管工', label: '配管工' },
    { value: '大工', label: '大工' },
    { value: '配達員', label: '配達員' },
    { value: '宅配ドライバー', label: '宅配ドライバー' },
    { value: '薬剤師', label: '薬剤師' },
    { value: '獣医', label: '獣医' },
    { value: '理学療法士', label: '理学療法士' },
    { value: '作業療法士', label: '作業療法士' },
    { value: '心理カウンセラー', label: '心理カウンセラー' },
    { value: '社会福祉士', label: '社会福祉士' },
    { value: '臨床検査技師', label: '臨床検査技師' },
    { value: '放射線技師', label: '放射線技師' },
    { value: '歯科医', label: '歯科医' },
    { value: '歯科衛生士', label: '歯科衛生士' },
    { value: '行政書士', label: '行政書士' },
    { value: '税理士', label: '税理士' },
    { value: '不動産業者', label: '不動産業者' },
    { value: '保険業', label: '保険業' },
    { value: '金融業', label: '金融業' },
    { value: '投資家', label: '投資家' },
    { value: '証券アナリスト', label: '証券アナリスト' },
    { value: '研究者', label: '研究者' },
    { value: 'マーケター', label: 'マーケター' },
    { value: 'データアナリスト', label: 'データアナリスト' },
    { value: 'アートディレクター', label: 'アートディレクター' },
    { value: 'プロジェクトマネージャー', label: 'プロジェクトマネージャー' },
    { value: 'コンサルタント', label: 'コンサルタント' },
    { value: '人事', label: '人事' },
    { value: '総務', label: '総務' },
    { value: '広報', label: '広報' },
    { value: '販売マネージャー', label: '販売マネージャー' },
    { value: 'カスタマーサポート', label: 'カスタマーサポート' },
    { value: '品質管理', label: '品質管理' },
    { value: '物流管理', label: '物流管理' },
    { value: 'オペレーションマネージャー', label: 'オペレーションマネージャー' },
    { value: 'イベントスタッフ', label: 'イベントスタッフ' },
    { value: '企画職', label: '企画職' },
    { value: 'その他', label: 'その他' }
  ];
  
  
  const educationOptions = [
    { value: '中学卒', label: '中学卒' },
    { value: '高校卒', label: '高校卒' },
    { value: '専門学校卒', label: '専門学校卒' },
    { value: '短大卒', label: '短大卒' },
    { value: '大学卒', label: '大学卒' },
    { value: '大学院卒', label: '大学院卒' },
    { value: 'その他', label: 'その他' }
  ];
  

  const figureOptions = [
    { value: '普通', label: '普通' },
    { value: '細身', label: '細身' },
    { value: '筋肉質', label: '筋肉質' },
    { value: 'がっしり', label: 'がっしり' },
    { value: 'ぽっちゃり', label: 'ぽっちゃり' },
    { value: 'ふくよか', label: 'ふくよか' },
    { value: 'その他', label: 'その他' }
  ];

  const sexOptions = [
    { value: '男性', label: '男性' },
    { value: '女性', label: '女性' },
    { value: 'トランス男性(FtM)', label: 'トランス男性(FtM)' },
    { value: 'トランス女性(MtF)', label: 'トランス女性(MtF)' },
    { value: 'ノンバイナリー', label: 'ノンバイナリー' },
    { value: 'その他', label: 'その他' }
  ];

 
  
  const meetingPreferenceOptions = [
    { value: 'パブリックな場所', label: 'パブリックな場所' },
    { value: '日中', label: '日中' },
    { value: '日中+パブリックな場所', label: '日中+パブリックな場所' },
  ];
  
  const purposeOptions = [
    { value: '友人', label: '友人' },
    { value: '恋人', label: '恋人' },
    { value: '結婚相手', label: '結婚相手' },
    { value: 'パートナー', label: 'パートナー' },
    { value: 'その他', label: 'その他' }
  ];
  
  const cohabiterAimOptions = [
    { value: '一緒に住みたい', label: '一緒に住みたい' },
    { value: '同居を希望しない', label: '同居を希望しない' },
    { value: '場合による', label: '場合による' },
  ];
  
  const marriageAimOptions = [
    { value: 'あり', label: 'あり' },
    { value: 'なし', label: 'なし' },
    { value: '場合による', label: '場合による' },
  ];
  
  const loveExistOptions = [
    { value: 'ある', label: 'ある' },
    { value: 'ない', label: 'ない' },
    { value: 'わからない', label: 'わからない' },
  ];
  
  const partnerSexOptions = [
    { value: '男性', label: '男性' },
    { value: '女性', label: '女性' },
    { value: 'トランス男性(FtM)', label: 'トランス男性(FtM)' },
    { value: 'トランス女性(MtF)', label: 'トランス女性(MtF)' },
    { value: 'ノンバイナリー', label: 'ノンバイナリー' },
    { value: 'その他', label: 'その他' }
  ];
  

  useEffect(() => {
    const fetchProfile = async () => {
      if (user) {
        const docRef = doc(db, 'members', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          // 生年月日をISO形式から分解して設定
          const birthday = new Date(data.birthday);
          const birthdayYear = birthday.getFullYear();
          const birthdayMonth = birthday.getMonth() + 1; // 月は0から始まるので+1
          const birthdayDay = birthday.getDate();
  
          setProfile({
            name: sanitizeInput(data.name).slice(0, MAX_NAME_LENGTH) || '',
            bio: sanitizeInput(data.bio).slice(0, MAX_BIO_LENGTH) || '',
            photoURL: data.photoURL || '',
            birthdayYear: birthdayYear || '',
            birthdayMonth: birthdayMonth || '',
            birthdayDay: birthdayDay || '',
            location: data.location || '',
            height: data.height || '',
            sexualOrientation: data.sexualOrientation || '',  // 追加
            holiday: data.holiday || '',
            contact: data.contact || '',
            cohabitant: data.cohabitant || '',
            tobacco: data.tobacco || '',
            alcohol: data.alcohol || '',
            hope: data.hope || '',
            income: data.income || '',
            aim: data.aim || '',
            children_want: data.children_want || '',
            children_have: data.children_have || '',
            marital_status: data.marital_status || '',
            skinship: data.skinship || '',
            educationc: data.educationc || '',
            works: data.works || '',
            figure: data.figure || '',
            sex: data.sex || '',
            love_exist: data.love_exist || '',
           marriage_aim : data.marriage_aim || '',
            spectrum: data.spectrum || '', // 追加
            cohabiter_aim: data.cohabiter_aim || '',
            partner_sex: data.partner_sex || [],
            friendship_marriage: data.friendship_marriage || '',
            hashtags: data.hashtags ? data.hashtags.map(tag => sanitizeInput(tag).slice(0, MAX_HASHTAG_LENGTH)).slice(0, MAX_HASHTAGS) : [],
            sub_photoURL_1: data.sub_photoURL_1 || '',
            sub_photoURL_2: data.sub_photoURL_2 || '',
            sub_photoURL_3: data.sub_photoURL_3 || '',
            sub_photoURL_3: data.sub_photoURL_4 || '',
            sub_photoURL_3: data.sub_photoURL_5 || '',
          });
          setImageUrl(data.photoURL || '');
          setSubImageUrls([
            data.sub_photoURL_1 || '',
            data.sub_photoURL_2 || '',
            data.sub_photoURL_3 || '',
            data.sub_photoURL_4 || '',
            data.sub_photoURL_5 || '',
          ]);
        } else {
          await setDoc(docRef, {
            name: '',
            bio: '',
            photoURL: '',
            birthdayYear: '',
            birthdayMonth: '',
            birthdayDay: '',
            location: '',
            height: '',
            grade: '',
            sexualOrientation: '',  // 初期値に追加
            holiday: '',
            contact: '',
            cohabitant: '',
            tobacco: '',
            alcohol: '',
            hope: '',
            income: '',
            aim: '',
            children_want: '',
            children_have: '',
            marital_status: '',
            skinship: '',
            educationc: '',
            works: '',
            figure: '',
            sex: '',
            spectrum: '',
            cohabiter_aim: '', // 同居の希望
            marriage_aim: '', // 結婚に対する意思
            love_exist: '', // 恋愛感情の有無
            friendship_marriage: '',
            partner_sex: [], // パートナーに望む性別
            hashtags: [],
            sub_photoURL_1: '',
            sub_photoURL_2: '',
            sub_photoURL_3: '',
            sub_photoURL_4: '',
            sub_photoURL_5: '',
          });
        }
      }
    };
    fetchProfile();
  }, [user]);

  

  const handleSave = async () => {
    if (user) {
      setUploading(true);
      const docRef = doc(db, 'members', user.uid);
  
      const uploadedImages = await Promise.all(
        subImages.map(async (image, index) => {
          if (image) {
            const croppedImage = await getCroppedImg(image, subCroppedAreas[index]);
            const storageRef = ref(storage, `sub_profile_images/${user.uid}/sub${index + 1}`);
            await uploadBytes(storageRef, croppedImage);
            const downloadURL = await getDownloadURL(storageRef);
            const newSubImageUrls = [...subImageUrls];
            newSubImageUrls[index] = downloadURL;
            setSubImageUrls(newSubImageUrls);
            return downloadURL;
          }
          return profile[`sub_photoURL_${index + 1}`];
        })
      );
      
  
      // 生年月日をISO形式で保存
      const birthday = new Date(profile.birthdayYear, profile.birthdayMonth - 1, profile.birthdayDay).toISOString();
  
      const updatedProfile = {
        ...profile,
        birthday,
        sub_photoURL_1: uploadedImages[0],
        sub_photoURL_2: uploadedImages[1],
        sub_photoURL_3: uploadedImages[2],
        sexualOrientation: profile.sexualOrientation, // 性的嗜好を追加
        updatedAt: new Date(), // 更新日時を追加
      };
  
      if (image) {
        const croppedImage = await getCroppedImg(image, croppedAreaPixels);
        const storageRef = ref(storage, `profile_images/${user.uid}`);
        await uploadBytes(storageRef, croppedImage);
        const photoURL = await getDownloadURL(storageRef);
        updatedProfile.photoURL = photoURL;
        setImageUrl(photoURL);
      }
  
      try {
        // `members` コレクションを更新
        await updateDoc(docRef, updatedProfile);
  
        // `backup_user_collection` に新しいデータを追加
        const backupCollectionRef = doc(db, 'backup_user_collection', user.uid);
        await setDoc(backupCollectionRef, {
          ...updatedProfile,
          backupId: new Date().toISOString(), // バックアップ用の一意なIDを追加
        });
  
        console.log('Profile updated and backed up successfully.');
        setProfile(updatedProfile);
      } catch (error) {
        console.error('Error updating profile:', error);
      } finally {
        setUploading(false);
      }
    }
  };
  
  
  

  const handleImageChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        alert("ファイルサイズは5MB以下にしてください。");
        return;
      }
      const validMimeTypes = ['image/jpeg', 'image/png'];
      if (!validMimeTypes.includes(file.type)) {
        alert("画像形式はJPEGまたはPNGのみ対応しています。");
        return;
      }
      setImage(URL.createObjectURL(file));
      setShowCropper(true);
    }
  };

  const handleSubImageChange = (e, index) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        alert("ファイルサイズは5MB以下にしてください。");
        return;
      }
      const validMimeTypes = ['image/jpeg', 'image/png'];
      if (!validMimeTypes.includes(file.type)) {
        alert("画像形式はJPEGまたはPNGのみ対応しています。");
        return;
      }
      const newSubImages = [...subImages];
      newSubImages[index] = URL.createObjectURL(file);
      setSubImages(newSubImages);
      setCurrentSubIndex(index);
      const newShowSubCropper = [...showSubCropper];
      newShowSubCropper[index] = true;
      setShowSubCropper(newShowSubCropper);
    }
  };  

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onSubCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    const newSubCroppedAreas = [...subCroppedAreas];
    newSubCroppedAreas[currentSubIndex] = croppedAreaPixels;
    setSubCroppedAreas(newSubCroppedAreas);
  }, [currentSubIndex, subCroppedAreas]);

  const handleAddHashtag = () => {
    if (newHashtag && profile.hashtags.length < MAX_HASHTAGS) {
      setProfile({ ...profile, hashtags: [...profile.hashtags, sanitizeInput(newHashtag).slice(0, MAX_HASHTAG_LENGTH)] });
      setNewHashtag('');
    }
  };

  const handleRemoveHashtag = (index) => {
    const updatedHashtags = profile.hashtags.filter((_, i) => i !== index);
    setProfile({ ...profile, hashtags: updatedHashtags });
  };

  const handleDeleteImage = async (index) => {
    const newSubImageUrls = [...subImageUrls];
    newSubImageUrls[index] = '';
    setSubImageUrls(newSubImageUrls);

    const newSubImages = [...subImages];
    newSubImages[index] = null;
    setSubImages(newSubImages);

    const updatedProfile = {
      ...profile,
      [`sub_photoURL_${index + 1}`]: ''
    };

    setProfile(updatedProfile);

    if (user) {
      const docRef = doc(db, 'members', user.uid);
      await updateDoc(docRef, updatedProfile);
    }
  };

  const handleDeleteProfileImage = async () => {
    setImageUrl('');
    const updatedProfile = {
      ...profile,
      photoURL: ''
    };
    setProfile(updatedProfile);

    if (user) {
      const docRef = doc(db, 'members', user.uid);
      await updateDoc(docRef, updatedProfile);
    }
  };

  return (
    <div className={`profile-edit-container ${uploading ? 'darkened' : ''}`}>
      {uploading && <div className="overlay">保存中...</div>}
      <div className="header">
        <Link to="/settings" className="back-link-cont">←</Link>
        <p className="settings-title-cont">アカウント設定</p>
      </div>
      <div className="profile-picture-container">
        <div className="image-container-x">
          {imageUrl ? (
            <img src={imageUrl} alt="Profile" className="profile-picture" />
          ) : (
            <img src="/images/default.png" alt="Default" className="profile-picture" />
          )}
          {imageUrl && (
            <button className="delete-icon" onClick={handleDeleteProfileImage}>
              &times;
            </button>
          )}
        </div>
        <br />
        <label className="custom-file-upload">
          プロフィール画像を選択
          <input type="file" onChange={handleImageChange} className="file-input" />
        </label>
      </div>

      <div className="sub-profile-picture-row">
  {[1, 2, 3, 4, 5].map((index) => (
    <div key={index} className="sub-profile-picture-container">
      <div className="image-container-x">
        {subImageUrls[index - 1] ? (
          <img src={subImageUrls[index - 1]} alt={`Sub ${index}`} className="sub-image" />
        ) : (
          <img src="/images/default.png" alt="Default" className="sub-image" />
        )}
        {subImageUrls[index - 1] && (
          <button className="delete-icon" onClick={() => handleDeleteImage(index - 1)}>
            &times;
          </button>
        )}
      </div>
      <label className="custom-file-upload-x">
        選択
        <input type="file" onChange={(e) => handleSubImageChange(e, index - 1)} className="file-input" />
      </label>
    </div>
  ))}
</div>

      <label>名前:</label>
      <div className="block-label">
        <input
          type="text"
          value={sanitizeInput(profile.name).slice(0, MAX_NAME_LENGTH)}
          onChange={(e) => setProfile({ ...profile, name: sanitizeInput(e.target.value).slice(0, MAX_NAME_LENGTH) })}
          placeholder="お名前（７文字まで）"
          className="profile-input"
        />
      </div>

      <label>自己紹介:</label>
      <div className="block-label">
        <textarea
          value={sanitizeInput(profile.bio).slice(0, MAX_BIO_LENGTH)}
          onChange={(e) => setProfile({ ...profile, bio: sanitizeInput(e.target.value).slice(0, MAX_BIO_LENGTH) })}
          placeholder="自己紹介(２０００文字まで)"
          className="profile-textarea"
        />
      </div>

      <h4>趣味タグ</h4>

      <div className="form-group-a">
<label>趣味:</label>
        {profile.hashtags.length < MAX_HASHTAGS && (
          <div>
            <div className="hashtag-input-container">
              <input
                type="text"
                value={newHashtag}
                onChange={(e) => setNewHashtag(sanitizeInput(e.target.value).slice(0, MAX_HASHTAG_LENGTH))}
                placeholder="10個まで"
                className="hashtag-input"
              />
              <button type="button" onClick={handleAddHashtag} className="hashtag-add-button">
                追加
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="hashtag-container">
        {(profile.hashtags || []).map((tag, index) => (
          <div key={index} className="hashtag">
            {sanitizeInput(tag).slice(0, MAX_HASHTAG_LENGTH)}
            <button type="button" onClick={() => handleRemoveHashtag(index)}>
              &times;
            </button>
          </div>
        ))}
      </div>

<h4>基本プロフィール（必須）<br></br><span className="lkjhg">※生年月日は相手に表示されません</span></h4>

<div className="block-label-x">
  
        <label>生年月日:</label>
        <div className="birthday-container">
          <Select
          isSearchable={false} // ここで検索ボックスを無効化
            value={yearOptions.find(option => option.value === profile.birthdayYear)}
            onChange={(selectedOption) => setProfile({ ...profile, birthdayYear: selectedOption.value })}
            options={yearOptions}
            placeholder="年"
            className="birthday-select"
          />
          <Select
          isSearchable={false} // ここで検索ボックスを無効化
            value={monthOptions.find(option => option.value === profile.birthdayMonth)}
            onChange={(selectedOption) => setProfile({ ...profile, birthdayMonth: selectedOption.value })}
            options={monthOptions}
            placeholder="月"
            className="birthday-select"
          />
          <Select
          isSearchable={false} // ここで検索ボックスを無効化
            value={dayOptions.find(option => option.value === profile.birthdayDay)}
            onChange={(selectedOption) => setProfile({ ...profile, birthdayDay: selectedOption.value })}
            options={dayOptions}
            placeholder="日"
            className="birthday-select"
          />
        </div>
      </div>
      <div className="form-group-a">
        <label>居住地:</label>
        <Select    isSearchable={false} // ここで検索ボックスを無効化
          value={locationOptions.find(option => option.value === profile.location)}
          onChange={(selectedOption) => setProfile({ ...profile, location: selectedOption.value })}
          options={locationOptions}
          placeholder="未選択"
          className="select-box"
        />
      </div>
      


      <div className="form-group-a">
  <label>性別:</label>
  <Select
    isSearchable={false} // ここで検索ボックスを無効化
    value={sexOptions.find(option => option.value === profile.sex)}
    onChange={(selectedOption) => setProfile({ ...profile, sex: selectedOption.value })}
    options={sexOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>Aceスペクトラム:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={spectrumOptions.find(option => option.value === profile.spectrum)}
    onChange={(selectedOption) => setProfile({ ...profile, spectrum: selectedOption.value })}
    options={spectrumOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>性的指向:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={sexualOrientationOptions.find(option => option.value === profile.sexualOrientation)}
    onChange={(selectedOption) => setProfile({ ...profile, sexualOrientation: selectedOption.value })}
    options={sexualOrientationOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>求める相手<br></br>(複数選択可):</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    isMulti
    value={purposeOptions.filter(option => profile.aim?.includes(option.value) || false)}

    onChange={(selectedOptions) =>
      setProfile({ ...profile, aim: selectedOptions.map(option => option.value) })
    }
    options={purposeOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>相手に望める性別<br></br>(複数選択可):</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    isMulti
    value={partnerSexOptions.filter(option => profile.partner_sex.includes(option.value))}
    onChange={(selectedOptions) =>
      setProfile({ ...profile, partner_sex: selectedOptions.map(option => option.value) })
    }
    options={partnerSexOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>



<div className="form-group-a">
  <label>会う時の希望:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={meetingPreferenceOptions.find(option => option.value === profile.hope)}
    onChange={(selectedOption) => setProfile({ ...profile, hope: selectedOption.value })}
    options={meetingPreferenceOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>



<h4>詳細項目</h4>

<div className="form-group-a">
  <label>身長：</label>
  <Select
      isSearchable={false} // ここで検索ボックスを無効化
    value={heightOptions.find(option => option.value === profile.height)}
    onChange={(selectedOption) => setProfile({ ...profile, height: selectedOption.value })}
    options={heightOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>体型：</label>
  <Select
    isSearchable={false} // ここで検索ボックスを無効化
    value={figureOptions.find(option => option.value === profile.figure)}
    onChange={(selectedOption) => setProfile({ ...profile, figure: selectedOption.value })}
    options={figureOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>収入：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={incomeOptions.find(option => option.value === profile.income)}
    onChange={(selectedOption) => setProfile({ ...profile, income: selectedOption.value })}
    options={incomeOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>職業：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={occupationOptions.find(option => option.value === profile.works)}
    onChange={(selectedOption) => setProfile({ ...profile, works: selectedOption.value })}
    options={occupationOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>学歴：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={educationOptions.find(option => option.value === profile.educationc)}
    onChange={(selectedOption) => setProfile({ ...profile, educationc: selectedOption.value })}
    options={educationOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>休日：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={holidayOptions.find(option => option.value === profile.holiday)}
    onChange={(selectedOption) => setProfile({ ...profile, holiday: selectedOption.value })}
    options={holidayOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>同居人：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={cohabitantOptions.find(option => option.value === profile.cohabitant)}
    onChange={(selectedOption) => setProfile({ ...profile, cohabitant: selectedOption.value })}
    options={cohabitantOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>連絡頻度：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={contactFrequencyOptions.find(option => option.value === profile.contact)}
    onChange={(selectedOption) => setProfile({ ...profile, contact: selectedOption.value })}
    options={contactFrequencyOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>
<div className="form-group-a">
  <label>タバコ：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={tobaccoOptions.find(option => option.value === profile.tobacco)}
    onChange={(selectedOption) => setProfile({ ...profile, tobacco: selectedOption.value })}
    options={tobaccoOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>
<div className="form-group-a">
  <label>アルコール：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={alcoholOptions.find(option => option.value === profile.alcohol)}
    onChange={(selectedOption) => setProfile({ ...profile, alcohol: selectedOption.value })}
    options={alcoholOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<h4>結婚・恋愛について（任意）</h4>

<div className="form-group-a">
  <label>結婚に対する意思:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={marriageAimOptions.find(option => option.value === profile.marriage_aim)}
    onChange={(selectedOption) => setProfile({ ...profile, marriage_aim: selectedOption.value })}
    options={marriageAimOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>スキンシップ許容度：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={skinshipOptions.find(option => option.value === profile.skinship)}
    onChange={(selectedOption) => setProfile({ ...profile, skinship: selectedOption.value })}
    options={skinshipOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>恋愛感情の有無:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={loveExistOptions.find(option => option.value === profile.love_exist)}
    onChange={(selectedOption) => setProfile({ ...profile, love_exist: selectedOption.value })}
    options={loveExistOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>


<div className="form-group-a">
  <label>友情結婚の希望:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={friendshipMarriageOptions.find(option => option.value === profile.friendship_marriage)}
    onChange={(selectedOption) => setProfile({ ...profile, friendship_marriage: selectedOption.value })}
    options={friendshipMarriageOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>子供の希望：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={childrenWantOptions.find(option => option.value === profile.children_want)}
    onChange={(selectedOption) => setProfile({ ...profile, children_want: selectedOption.value })}
    options={childrenWantOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>
<div className="form-group-a">
  <label>子供の有無：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={childrenHaveOptions.find(option => option.value === profile.children_have)}
    onChange={(selectedOption) => setProfile({ ...profile, children_have: selectedOption.value })}
    options={childrenHaveOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>結婚歴：</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={maritalStatusOptions.find(option => option.value === profile.marital_status)}
    onChange={(selectedOption) => setProfile({ ...profile, marital_status: selectedOption.value })}
    options={maritalStatusOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>同居の希望:</label>
  <Select
  isSearchable={false} // ここで検索ボックスを無効化
    value={cohabiterAimOptions.find(option => option.value === profile.cohabiter_aim)}
    onChange={(selectedOption) => setProfile({ ...profile, cohabiter_aim: selectedOption.value })}
    options={cohabiterAimOptions}
    placeholder="未選択"
    className="select-box"
  />
</div>



  



      <div className="button-container">
        <button onClick={handleSave} className="save-button">保存</button>
      </div>
      {showCropper && (
        <div className="crop-container">
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
          <div className="crop-controls">
            <button onClick={() => setShowCropper(false)} className="crop-button1 close1">Close</button>
            <button onClick={handleSave} className="crop-button1 ok">OK</button>
          </div>
        </div>
      )}
      {showSubCropper.map((show, index) => (
        show && (
          <div key={index} className="crop-container">
            <Cropper
              image={subImages[index]}
              crop={crop}
              zoom={zoom}
              aspect={1}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onSubCropComplete}
            />
            <div className="crop-controls">
              <button onClick={() => {
                const newShowSubCropper = [...showSubCropper];
                newShowSubCropper[index] = false;
                setShowSubCropper(newShowSubCropper);
              }} className="crop-button1 close1">Close</button>
              <button onClick={handleSave} className="crop-button1 ok">OK</button>
            </div>
          </div>
        )
      ))}
      <MenuBar />
    </div>
  );
};

export default ProfileEdit;
